import { render, staticRenderFns } from "./addBankCard.vue?vue&type=template&id=9e10c9c0&scoped=true&"
import script from "./addBankCard.vue?vue&type=script&lang=js&"
export * from "./addBankCard.vue?vue&type=script&lang=js&"
import style0 from "./addBankCard.vue?vue&type=style&index=0&id=9e10c9c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e10c9c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e10c9c0')) {
      api.createRecord('9e10c9c0', component.options)
    } else {
      api.reload('9e10c9c0', component.options)
    }
    module.hot.accept("./addBankCard.vue?vue&type=template&id=9e10c9c0&scoped=true&", function () {
      api.rerender('9e10c9c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/addBank/components/addBankCard.vue"
export default component.exports